var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useImperativeHandle, forwardRef } from "react";
import RcTrigger from "rc-trigger";
import { placements } from "./placements";
import Popup from "./Popup";
var Trigger = function (props, ref) {
    var overlayClassName = props.overlayClassName, _a = props.trigger, trigger = _a === void 0 ? ["hover"] : _a, _b = props.mouseEnterDelay, mouseEnterDelay = _b === void 0 ? 0 : _b, _c = props.mouseLeaveDelay, mouseLeaveDelay = _c === void 0 ? 0.1 : _c, overlayStyle = props.overlayStyle, _d = props.prefixCls, prefixCls = _d === void 0 ? "mex-tooltip" : _d, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, motion = props.motion, _e = props.placement, placement = _e === void 0 ? "right" : _e, _f = props.align, align = _f === void 0 ? {} : _f, _g = props.destroyTooltipOnHide, destroyTooltipOnHide = _g === void 0 ? false : _g, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, showArrow = props.showArrow, _h = props.colorType, colorType = _h === void 0 ? "white" : _h, restProps = __rest(props, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow", "colorType"]);
    var prefixBaseOnColor = colorType === "white" ? prefixCls : "".concat(prefixCls, "-").concat(colorType);
    var domRef = useRef(null);
    useImperativeHandle(ref, function () { return domRef.current; });
    var extraProps = __assign({}, restProps);
    if ("visible" in props) {
        extraProps.popupVisible = props.visible;
    }
    var getPopupElement = function () {
        return (_jsx(Popup, __assign({ showArrow: showArrow, arrowContent: arrowContent, prefixCls: prefixBaseOnColor, id: id, overlayInnerStyle: overlayInnerStyle, colorType: colorType }, { children: overlay }), "content"));
    };
    var destroyTooltip = false;
    var autoDestroy = false;
    if (typeof destroyTooltipOnHide === "boolean") {
        destroyTooltip = destroyTooltipOnHide;
    }
    else if (destroyTooltipOnHide && typeof destroyTooltipOnHide === "object") {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip = keepParent === true;
        autoDestroy = keepParent === false;
    }
    return (_jsx(RcTrigger, __assign({ popupClassName: overlayClassName, prefixCls: prefixBaseOnColor, popup: getPopupElement, action: trigger, builtinPlacements: placements, popupPlacement: placement, ref: domRef, popupAlign: align, getPopupContainer: getTooltipContainer, onPopupVisibleChange: onVisibleChange, afterPopupVisibleChange: afterVisibleChange, popupMotion: motion, defaultPopupVisible: defaultVisible, destroyPopupOnHide: destroyTooltip, autoDestroy: autoDestroy, mouseLeaveDelay: mouseLeaveDelay, popupStyle: overlayStyle, mouseEnterDelay: mouseEnterDelay }, extraProps, { children: children ? children : _jsx("span", {}) })));
};
export default forwardRef(Trigger);
